import { bool } from 'prop-types';
import React, { PureComponent } from 'react';
import { ScrollView } from 'react-native';

import { C, LAYOUT } from '../../common';
import { CardStory } from '../../components';
import { Consumer } from '../../context';
import {
  Button, Motion, Text, Viewport,
} from '../../reactor/components';
import { THEME } from '../../reactor/common';
import styles from './Stories.style';

const { AMPLITUDE: { CLICK_TYPE, ON_CLICK } } = C;
const CONTAINER_LEFT = -2560;
const { MOTION: { DURATION } } = THEME;

class Stories extends PureComponent {
  _onClose = ({ logEvent, onStories }) => {
    logEvent(ON_CLICK, { type: CLICK_TYPE.STORIES_CLOSE });
    onStories();
  }

  render() {
    const { _onClose, props: { visible } } = this;

    return (
      <Consumer>
        { ({
          l10n, dataSource: { related = [] } = {}, ...context
        }) => (
          <Motion
            duration={DURATION / 2}
            style={styles.container}
            timeline={[{ property: 'translateX', value: visible ? 0 : CONTAINER_LEFT }]}
          >
            <Viewport>
              <Button contained={false} icon="close" onPress={() => _onClose(context)} rounded style={styles.button} />
              <Text headline level={6} style={[LAYOUT.STYLE.chapter, styles.title]}>
                {l10n.MORE_STORIES}
              </Text>
              <ScrollView contentContainerStyle={styles.cards}>
                { related.map((data, index) => (
                  <CardStory key={data.uri} data={data} index={index} visible={visible} />)) }
              </ScrollView>
            </Viewport>
          </Motion>
        )}
      </Consumer>
    );
  }
}

Stories.propTypes = {
  visible: bool,
};

Stories.defaultProps = {
  visible: false,
};

export default Stories;
